import LoginPopup from "@/common/LoginPopup";
import chatService from "@/service/chat.service";
import { Box, Typography, useTheme } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

function ConversationSection({ VendorDetail }) {
  const navigate = useNavigate();
  const isAuthenticated = Boolean(localStorage.getItem("access_token"))
  const [hasConversation, setHasConversation] = useState(false);
  const theme = useTheme();
  const [showPopup, setShowPopup] = useState(false);
  const [redirectUrl, setRedirectUrl] = useState("");

  useEffect(() => {
    const checkConversation = async () => {
      try {
        if (!VendorDetail?._id) {
          console.error("Vendor ID is missing!");
          return;
        }
        const response = await chatService.checkConversation(VendorDetail._id);
        setHasConversation(response.hasConversation);
      } catch (error) {
        console.error("Failed to check conversation:", error);
      }
    };
    checkConversation();
  }, [VendorDetail._id]);

  const handleImageClick = () => {
    if (!VendorDetail?._id) {
      console.error("Vendor ID is missing!");
      return;
    }
    if (!isAuthenticated) {
      setRedirectUrl("/customer/auth/login");
      setShowPopup(true);
    } else {
      console.log("VendorDetail._id=",VendorDetail._id);
      navigate("/customer/inbox", { state: { vendorId: VendorDetail._id } });
    }
  };

  return (
    <>
      <Box
        sx={{
          backgroundColor: "#fbfcff",
          border: "1px solid #d9d9d9",
          display: "flex",
          flexWrap: "wrap",
          alignItems: "flex-start",
          gap: { xs: "24px", md: "40px 100px" },
          width: "100%",
          mt: 1,
          p: { xs: "39px 20px", md: "20px 80px 20px 39px" },
          fontFamily: "Poppins, -apple-system, Roboto, Helvetica, sans-serif"
        }}
      >
        <Box sx={{ flex: 1 }}>
          <Typography variant="h6" fontWeight={600} gutterBottom>
            Start a Conversation with the Expert
          </Typography>
          <Typography
            variant="body1"
            sx={{
              color: "#6e6d6a",
              fontSize: "16px",
              fontWeight: 400
            }}
          >
            Have questions? Connect directly with the Experts to discuss your
            needs.
          </Typography>
        </Box>

        <Box
          component="img"
          src="https://cdn.builder.io/api/v1/image/assets/9094226ff89f4a689e6e762286383a3d/8063dd282452e243aa5cb6763c64707c0d59b81388a0dd3791667cecf41d92fb?placeholderIfAbsent=true"
          alt="Message icon"
          onClick={handleImageClick}
          sx={{
            width: "48px",
            aspectRatio: "1",
            objectFit: "contain",
            objectPosition: "center",
            flexShrink: 0,
            cursor: "pointer",
            color: "#6d50e2"
          }}
        />
      </Box>
      {showPopup && (
        <LoginPopup
          onClose={() => setShowPopup(false)}
          redirectUrl={redirectUrl}
        />
      )}</>
  );
}

export default ConversationSection;
